/**
 * @generated SignedSource<<39a890a3ad6c16a96e6af6ef396b1b85>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HeroCarouselImage_sortedPhoto$data = {
  readonly alt: string | null;
  readonly masterOrZoomPath: string | null;
  readonly " $fragmentType": "HeroCarouselImage_sortedPhoto";
};
export type HeroCarouselImage_sortedPhoto$key = {
  readonly " $data"?: HeroCarouselImage_sortedPhoto$data;
  readonly " $fragmentSpreads": FragmentRefs<"HeroCarouselImage_sortedPhoto">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HeroCarouselImage_sortedPhoto",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "masterOrZoomPath",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "alt",
      "storageKey": null
    }
  ],
  "type": "ItemPhoto",
  "abstractKey": null
};

(node as any).hash = "c293f308ce5028055dafb94ea0471116";

export default node;
